import { FileUploadTableEditorContextProps } from '@/components/file-upload-table/FileUploadTable.component';

import { createContext } from 'react';

export const FileUploadTableEditorContext =
  createContext<FileUploadTableEditorContextProps | null>(null);
